import {Pipe} from '@angular/core';
import {Timestamp} from '@firebase/firestore';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: "timeAgo",
    standalone: true
})
export class TimeAgoPipe {
  constructor(private translateService: TranslateService) {}

  transform(createdAt: Timestamp) {
    return this.calculateTimeAgo(createdAt)
  }

  calculateTimeAgo(createdAt): string {

    const timestamp = (new Timestamp(createdAt.seconds, createdAt.nanoseconds)).toDate();

    // const timestamp = createdAt.toDate();
    const currentDate = new Date();
    const inputDate = timestamp;

    const timeDifference = currentDate.getTime() - inputDate.getTime();
    const seconds = Math.floor(timeDifference / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const months = Math.floor(days / 30);
    const weeks = Math.floor(days / 7);
    const years = Math.floor(days / 365);

    if (years > 1) {
      return this.translateService.instant("common.yearsAgo", { value: years });
    } else if (years == 1) {
      return this.translateService.instant("common.yearAgo", { value: years });
    } else if (months > 1) {
      return this.translateService.instant("common.monthsAgo", { value: months });
    } else if (months == 1) {
      return this.translateService.instant("common.monthAgo", { value: months });
    } else if (weeks > 1) {
      return this.translateService.instant("common.weeksAgo", { value: weeks });
    } else if (weeks == 1) {
      return this.translateService.instant("common.weekAgo", { value: weeks });
    } else if (days > 1) {
      return this.translateService.instant("common.daysAgo", { value: days });
    } else if (days == 1) {
      return this.translateService.instant("common.dayAgo", { value: days });
    } else if (hours > 1) {
      return this.translateService.instant("common.hoursAgo", { value: hours });
    } else if (hours == 1) {
      return this.translateService.instant("common.hourAgo", { value: hours });
    } else if (minutes > 0) {
      return this.translateService.instant("common.minAgo", { value: minutes });
    } else if (seconds > 0) {
      return this.translateService.instant("common.secAgo", { value: seconds });
    } else {
      // Handle the "just now" case
      return this.translateService.instant("common.justNow");
    }
  }

}
